import { where, writeBatch } from "firebase/firestore";
import { ParentContext } from "global/cnr/contexts/ParentContext";
import { _cacheGroupTypes } from "global/cnr/contexts/useHelpers/useTimestamp";
import { logBatch } from "global/cnr/reducers/reducerHelpers/logging";
import { createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import _ from 'lodash';
import { useCallback, useContext, useState } from "react";
import { SportsSeasonContext } from "../cnr/contexts/SportsSeasonContext";
import { seasonalHelpers } from "../cnr/reducers/reducerHelpers/seasonalHelpers";
import { SportsDistrictContext } from "../cnr/contexts/SportsDistrictContext";

const _allowTeamSportsUpdate = true
const _allowTeamUpdate = false
const _allowTeamsUpdate = false

export const useSportsTeams = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { database_fns } = fns ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainDb } = app_state ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { sports } = sportsDistrict_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info } = sportsSeason_state ?? {}
  const { sportsKey } = currentSeason_info ?? {}

  const [updating, setUpdating] = useState()

  const getSportsTeams = useCallback(async () => {
    if (!_allowTeamsUpdate) return;

    const currentRef_team = createRefPath_event(pathViews, ['teams'])
    const teams = await database_fns.get_data({ refPath: currentRef_team })
    console.log('teams', teams)
    console.log('sports', sports)
    const grouped = _.groupBy(teams, (team) => {
      const districts = team.parentKeys?.districts || 'none';
      const organizations = team.parentKeys?.organizations || 'none';
      const sports = team.parentKeys?.sports || 'none';
      return `${districts}__${organizations}__${sports}`;
    });
    const _groups = _.reduce(grouped, (result, listOfTeams, groupKey) => {
      const firstTeam = _.first(listOfTeams);
      result[database_fns.get_docKey()] = {
        teams: _.reduce(listOfTeams, (teamsResult, team) => {
          teamsResult[team._itemKey] = {
            name: team.name
          };
          return teamsResult;
        }, {}),
        sport: sports?.[firstTeam?.parentKeys?.sports]?.name,
        parentKeys: {
          districts: firstTeam?.parentKeys?.districts || null,
          organizations: firstTeam?.parentKeys?.organizations || null,
          sports: firstTeam?.parentKeys?.sports || null,
        }
      };
      return result;
    }, {});

    const batch = writeBatch(mainDb);

    _.forEach(_groups, (grp, grpKey) => {
      const currentRef = createRefPath_event(pathViews, ['_teams_sport', grpKey])
      database_fns.set_doc(currentRef, grp, false, null, batch)
    })

    if (_allowTeamsUpdate) {
      await batch.commit()
    }


  }, []);

  const get_teamsSport = useCallback(async ({ callback }) => {
    const pks_team = seasonalHelpers.getPks(pathViews)
    const wheres_team = getWheres(pks_team)
    const currentRef = createRefPath_event(pathViews, ['_teams_sport'])

    const { item, fk } = await database_fns.get_data({
      refPath: currentRef,
      wheres: wheres_team,
      opts: { returnFirstObject: true, ignoreId: true, returnKey: true }
    })

    callback({ item, fk })

  }, []);

  const updateTeams_sport = useCallback(async ({ teams, _sportsAbr, _sportsModeSport, callback }) => {

    const cb = () => {
      setUpdating(false)
      callback()
    }


    setUpdating(true)

    const pks_team = seasonalHelpers.getPks(pathViews)
    const wheres_team = getWheres(pks_team)
    const currentRef = createRefPath_event(pathViews, ['_teams_sport'])

    const { item, fk } = await database_fns.get_data({
      refPath: currentRef,
      wheres: wheres_team,
      opts: { returnFirstObject: true, ignoreId: true, returnKey: true }
    })

    const batch = writeBatch(mainDb);

    let teamSportKey = fk;

    if (!item) {

      // lets create it 
      teamSportKey = `${_sportsAbr}_${database_fns.get_docKey()}`

      const currentRef_add = createRefPath_event(pathViews, ['_teams_sport', teamSportKey])

      const dataToAdd = {
        parentKeys: { ...pks_team },
        sport: _.startCase(_sportsModeSport)
      }

      database_fns.set_doc(currentRef_add, dataToAdd, true, null, batch);

      console.log('currentRef_add', _sportsModeSport, currentRef_add, dataToAdd)

    }

    if (teamSportKey) {

      const dataToUpdate = {}

      _.forEach(teams, team => {

        dataToUpdate[`teams.${team._itemKey}`] = { name: team.name }

        const _pks_team = _.cloneDeep(pks_team)

        if (team._schoolKey) {
          _pks_team.schools = team._schoolKey
        }

        const teamToUpdate = {
          name: team.name,
          parentKeys: _pks_team
        }

        const currentRef_team = createRefPath_event(pathViews, ['teams', team._itemKey])
        database_fns.set_doc(currentRef_team, teamToUpdate, true, null, batch);
      })

      const currentRef_item = createRefPath_event(pathViews, ['_teams_sport', teamSportKey])
      database_fns.update_doc(currentRef_item, dataToUpdate, null, batch);

      logBatch(batch, dataToUpdate)

      if (_allowTeamSportsUpdate) {
        const _timestamp = Date.now()
        database_fns.update_timestamp(_cacheGroupTypes.sportsSeasonInfo, pathViews.sports, _timestamp, batch)
        await batch.commit()
      }
    }

    cb()

  }, []);

  const updateSportsTeams = useCallback(async ({ teamName, callback }) => {

    const cb = () => {
      setUpdating(false)
      callback()
    }

    setUpdating(true)

    const pks_team = seasonalHelpers.getPks(pathViews)
    const pks_school = seasonalHelpers.getPks(pathViews, null, null, ['sports'])

    const schoolKey = database_fns.get_docKey()
    const teamKey = database_fns.get_docKey()

    const wheres_team = getWheres_team(pks_team, teamName)
    const wheres_school = getWheres_team(pks_school, teamName)

    const currentRef_team = createRefPath_event(pathViews, ['teams'])
    const { item: team_existing, fk: team_fk } = await database_fns.get_data({ refPath: currentRef_team, wheres: wheres_team, opts: { returnFirstObject: true, ignoreId: true, returnKey: true } })

    const currentRef_school = createRefPath_event(pathViews, ['schools'])
    const { item: school_existing, fk: school_fk } = await database_fns.get_data({ refPath: currentRef_school, wheres: wheres_school, opts: { returnFirstObject: true, ignoreId: true, returnKey: true } })

    console.log('school_existing', school_fk, school_existing)
    console.log('team_existing', team_fk, team_existing)

    const batch = writeBatch(mainDb);

    if (!school_existing) {
      const school_new = {
        name: teamName,
        parentKeys: {
          organizations: pathViews.organizations,
          districts: pathViews.districts,
        }
      }
      const currentRef_schools = createRefPath_event(pathViews, ['schools', schoolKey])
      console.log('currentRef_schools', currentRef_schools, school_new)
      database_fns.set_doc(currentRef_schools, school_new, false, null, batch)
    }

    if (!team_existing) {
      const team_new = {
        name: teamName,
        parentKeys: {
          organizations: pathViews.organizations,
          districts: pathViews.districts,
          schools: school_fk || schoolKey,
          sports: sportsKey,
        }
      }
      const currentRef_teams = createRefPath_event(pathViews, ['teams', teamKey])
      console.log('currentRef_teams', currentRef_teams, team_new)
      database_fns.set_doc(currentRef_teams, team_new, false, null, batch)
    }

    logBatch(batch)

    if (_allowTeamUpdate) {
      const _timestamp = Date.now()
      database_fns.update_timestamp(_cacheGroupTypes.sportsSeasonInfo, pathViews.sports, _timestamp, batch)
      await batch.commit()
      cb()
    }

    cb()
  }, []);

  return { updateSportsTeams, updateTeams_sport, getSportsTeams, get_teamsSport, updating }

}

const getWheres_team = (pks, teamName) => {
  const wheres = _.map(pks, (value, pk) => {
    return where('parentKeys.' + pk, '==', value)
  })
  wheres.push(where('name', '==', teamName))
  return wheres
}

const getWheres = (pks) => {
  const wheres = _.map(pks, (value, pk) => {
    return where('parentKeys.' + pk, '==', value)
  })
  return wheres
}